module.exports = __webpack_public_path__ + "static/media/captions_Peerless.345a528a.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Peerless.vtt
// module id = 123
// module chunks = 0